module.exports = __webpack_public_path__ + "static/img/fullscreen-image_hero_768.15e2f24.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/complete/fullscreen-image_hero_768.png
// module id = 2Hkd
// module chunks = 0